import CustomButton, { CustomButtonProps } from "components/Atoms/CustomButton"
import React from "react"
type CloseButtonProps = CustomButtonProps & {}
const CloseButton = ({ ...props }: CloseButtonProps) => (
  <CustomButton minimal icon="cross" {...props} />
)

export default CloseButton
